// extracted by mini-css-extract-plugin
export var cartIcon = "_nc-0";
export var cartIconContainer = "_nc-1";